<div *ngIf="testQuestions?.length > 0">
	<h4 class="text-center mt-2">{{selectedPhase?.[0]?.title}}</h4>

	<div class="modal-header w-100">
		<h5 class="modal-title" id="test-modal">
			Test Date

			<div class="date-modal card-header" [ngClass]="isValidDate == false ? 'border border-danger' : ''">
				<input
					id="testDate"
					[readonly]="true"
					class="date-modal card-header"
					placeholder="yyyy-mm-dd"
					name="dp"
					ngbDatepicker
					#dp="ngbDatepicker"
					[(ngModel)]="testDate"
					[positionTarget]="calendarbtn"
					[maxDate]="endDate"
					[minDate]="startDate"
					(dateSelect)="dateChangeEvent()" />
				{{ testDate.year }}-{{ testDate.month }}-{{ testDate.day }}
				<button class="btn btn-secondary" (click)="dp.toggle()" type="button" #calendarbtn>
					<i class="fa fa-calendar" aria-hidden="true"></i>
				</button>
			</div>
		</h5>

		<button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
			<span aria-hidden="true">&times;</span>
		</button>
	</div>

	<div class="modal-body p-0">
		<h5 class="text-center" *ngIf="previousYear">New School Year Placement</h5>

		<div class="table-responsive score-record-table-padding">
			<table class="table bg-primary table-striped table-hover p-5 boxed" [ngSwitch]="previousYear">
				<th class="score-record-table-header">Challenge</th>
				<th colspan="4" class="score-record-table-header score-th">Scores</th>
				<th class="score-record-table-header score-th no-change-header" *ngSwitchCase="false">No Change</th>
				<tr *ngFor="let eachQuestion of testQuestions[page - 1]; let i = index">
					<td class="score-record-table-data">
						<span [ngClass]="rsp.media.is_mobile ? 'text-truncate set-max' : ''" class="badge mr-1 badge-secondary labelcolor-{{ eachQuestion.testId }}">
							<span class="d-sm-none">{{ findChallengeNumber(testQuestions, page, i) + '. ' }}</span>
							<span class="d-none d-sm-inline">{{ eachQuestion.label }}</span>
						</span>
						<span class="d-none d-lg-inline">{{ eachQuestion.question }}</span>
					</td>
					<td
						*ngFor="let answer of eachQuestion.scorings"
						style="width: 50px"
						class="score-record-table-data score-td"
						[ngClass]="testQuestions[page - 1][i].lastYearScore == answer ? 'lastYearScoreAssessment ' : ''">
						<input
							type="radio"
							name="{{ eachQuestion.id }}"
							id="{{ eachQuestion.id }}-{{ answer }}"
							[value]="answer"
							[(ngModel)]="testQuestions[page - 1][i].latestScore"
							(change)="handleChangeRadio(eachQuestion)" />
						<label for="{{ eachQuestion.id }}-{{ answer }}">{{ answer }}</label>
					</td>
					<td class="score-record-table-data score-td no-change-cell" *ngSwitchCase="false">
						<input
							type="checkbox"
							name="{{ eachQuestion.id }}-zero-progress"
							id="{{ eachQuestion.id }}-zero-progress"
							[(ngModel)]="previousScoresMatchScoredTQs[testQuestions[page - 1][i].id]"
							(click)="handleZeroProgress(eachQuestion, $event)" />
						<label for="{{ eachQuestion.id }}-zero-progress"></label>
					</td>
				</tr>
				<tfoot>
					<tr></tr>
				</tfoot>
			</table>
		</div>
	</div>
	<div class="modal-footer">
		<div class="float-left pr-2" *ngIf="previousYear">
			<div class="lastYearScoreAssessment"></div>
			<span class="ml-3">Previous year score </span>
		</div>
		<div *ngIf="previousYear" class="no-change-instructions">
			(<a href="https://support.confidentlearners.com/hc/en-ca/articles/18764076688539-Placement-Assessment-Protocol" target="_blank">Instructions for placement</a>)
		</div>
		<div *ngIf="!previousYear" class="no-change-instructions">
			*
			<a href="https://support.confidentlearners.com/hc/en-ca/articles/12114810507163-No-Change-Assessments" target="_blank"> Instructions for when there is no change in score </a>
		</div>
		<div class="row w-100">
			<div class="col-lg-4"></div>
			<ngb-pagination [(page)]="page" [collectionSize]="testQuestionsTotal * 2" class="col-lg-4">
				<ng-template ngbPaginationPrevious>
					<button type="button" class="btn btn-lg btn-primary h-100 w-100">
						<i class="fa fa-backward" aria-hidden="true"></i>
					</button>
				</ng-template>
				<ng-template ngbPaginationNext>
					<button type="button" class="btn btn-lg btn-primary h-100 w-100">
						<i class="fa fa-forward" aria-hidden="true"></i>
					</button>
				</ng-template>
				<ng-template ngbPaginationPages let-page let-pages="testHistory">
					<div class="page-tracker">{{ page }} / {{ testQuestions.length }}</div>
				</ng-template>
			</ngb-pagination>
			<div class="col-lg-4"></div>
		</div>
		<button type="button" class="btn btn-dark" (click)="activeModal.close()">Cancel</button>
		<button class="btn btn-success" (click)="submitScores()">Submit</button>
	</div>
</div>
